.error {
  bottom: -1px;
  left: 0;
  font-size: 12px;
  line-height: 16px;
  color: #f76060;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  img {
    width: 12px;
    margin-right: 2px;
  }
}

// Dark mode
:global body.dark {
  :local {
    .error {
      color: #E44A08;
      p {
        color: #E44A08;
      }
    }
  }
}
